import { render, staticRenderFns } from "./InventoryItemSizing.vue?vue&type=template&id=00c77d5c&scoped=true"
import script from "./InventoryItemSizing.vue?vue&type=script&lang=js"
export * from "./InventoryItemSizing.vue?vue&type=script&lang=js"
import style0 from "./InventoryItemSizing.vue?vue&type=style&index=0&id=00c77d5c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00c77d5c",
  null
  
)

export default component.exports